import { View } from "react-native";
import FloatingNotificationDot from "./components/FloatingNotificationDot";
import { NotificationDotProps } from "./types";

const NotificationDotContent = ({ children, size = 14 }: Omit<NotificationDotProps, "enabled">) => {
	return (
		<View testID="NotificationDotWrapper">
			{children}
			<FloatingNotificationDot size={size} />
		</View>
	);
};

const NotificationDot = ({ enabled = true, children, ...props }: NotificationDotProps) => {
	if (!enabled) {
		return children;
	}
	return <NotificationDotContent {...props}>{children}</NotificationDotContent>;
};
export default NotificationDot;
